import React, { useEffect, useRef } from 'react';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import OktaSignIn from '@okta/okta-signin-widget';
import logo from '../../logo.svg';

type LProps = {
  baseUrl: string;
  history: any;
  onSuccess: any;
  onError: any;
};

const Login = ({ baseUrl, history }: LProps) => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const token = localStorage.getItem('okta-token-storage');
  type Token = {
    idToken?: string;
  };
  let parsedToken: Token = {};
  if (token) {
    parsedToken = JSON.parse(token);
  }
  useEffect(() => {
    if (parsedToken.idToken) {
      history.push('/');
    }

    const { pkce, issuer, clientId, redirectUri, scopes } = window['oidc'];
    const config = {
      baseUrl: issuer.split('/oauth2')[0],
      clientId,
      redirectUri,
      logo,
      i18n: {
        en: {
          'primaryauth.title': 'Sign in to RAM',
        },
      },
      authParams: {
        pkce,
        issuer,
        display: 'page',
        responseMode: pkce ? 'query' : 'fragment',
        scopes,
      },
    };
    const widget = new OktaSignIn(config);
    return () => widget.remove();
  }, [history, parsedToken]);

  return (
    <div style={{ marginTop: 100 }}>
      <div ref={widgetRef} />
    </div>
  );
};
export default Login;
